import React, { useEffect,useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box, 
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles
} from '@material-ui/core';
import { 
  BarChart as BarChartIcon, 
  Settings as SettingsIcon, 
  User as UserIcon, 
  Users as UsersIcon
} from 'react-feather';
import NavItem from './NavItem';
import PersonIcon from '@material-ui/icons/Person'; 

const items = [
  {
    href: '/app/dashboard',
    icon: BarChartIcon,
    title: 'Dashboard'
  }, 
  {
    href: '/app/affidavit',    
    icon: BarChartIcon,
    title: 'Return Filling Affidavit'    
  },
  {
    href: '/app/vendor',
    icon: UsersIcon,
    title: 'Vendors'
  },
  {
    href: '/app/account',
    icon: UserIcon,
    title: 'Account'
  } 
];

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => { 
  const classes = useStyles();
  const location = useLocation();
  const [user,setUser]=useState({}); 
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    } 
  }, [location.pathname]);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        p={2}
      >
        <Avatar
          className={classes.avatar}
          component={RouterLink} 
          to="/app/account"
        ><PersonIcon/></Avatar>
        <Typography
          className={classes.name}
          color="textPrimary"
          variant="h5"
        >
          {user.Name}
        </Typography>
        <Typography
          color="textSecondary"
          variant="body2"
        >
          {user.CompanyName}
        </Typography>
      </Box>
      <Divider />
      <Box p={2}>
        <List>
          {items.map((item) => (
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
              subItem={item.subItems}
            />       
          ))}
        </List>
      </Box>
      <Box flexGrow={1} />
  
    </Box>
  ); 
  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
  userSession:PropTypes.object
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default NavBar;
